import React from 'react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { BonoItem } from './BonoItem';
import { bonos } from '../data/bonos';
export function BonosSection() {
  return <section className="bg-mp-black py-20 md:py-28" data-id="element-59" data-mp="13cw2msp6osen">
      <Container data-id="element-60" data-mp="13bl16zj7nwqp">
        <div className="max-w-[700px]" data-id="element-61" data-mp="yf2z67f9mci2">
          <SectionTag tone="lime" data-id="element-62" data-mp="yebcjm3nbp3x">Y para que no se quede en teoría...</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-63" data-mp="tgsyxieoolpl">
            Te llevas 5 herramientas de ejecución.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-64" data-mp="kejr50asv6fw">
            Diseñadas para ayudarte a aplicar el sistema desde las primeras clases.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-65" data-mp="2etmcclstg2d0">
          {bonos.map(bono => <BonoItem key={bono.number} bono={bono} data-id="element-66" data-mp="29v1ayj1tvcmz" />)}
        </div>
      </Container>
    </section>;
}